import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Storage from 'vue-ls'
import { VueAxios } from '@/utils/request'
// import Antd from 'ant-design-vue'
import { Menu, Icon, Upload, Table, Button, Modal, Popconfirm, notification, Spin, Card, Pagination, Input, Select, message, Tooltip, Form } from 'ant-design-vue'

import store from './store/'
import config from '@/defaultSettings'
Vue.config.productionTip = false
Vue.use(Storage, config.storageOptions)
Vue.use(VueAxios, router)
// Vue.use(Antd)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Upload)
Vue.use(Table)
Vue.use(Button)
Vue.use(Modal)
Vue.use(Popconfirm)
Vue.use(Spin)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Form)


Vue.use(notification)

Vue.prototype.$message = message


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
